export function isNutsCode(value?: string) {
  const regexp = /^CZ([0-9]|Z){0,3}$/;

  if (value) {
    return regexp.test(value);
  }

  return true;
}
